import React, { useEffect, useRef, useState } from 'react';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { ProgressSpinner } from 'primereact/progressspinner';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import GetAppIcon from '@mui/icons-material/GetApp';
import './customVideoPlayerForDetailsPage.css';
import { toast } from "../Toast/toast.ts";
import PlaybackSpeedDropDown from './PlaybackSpeedDropDown.tsx';
// import ShareIcon from '@mui/icons-material/Share';
// import { Tooltip } from '@mui/material';

//import { useMediaQuery } from '@mui/material';

const CustomVideoPlayerSecond = ({ src, videoName }) => {
  const videoRef = useRef(null);
  const [paused, setPaused] = useState(true);
  const [muted, setMuted] = useState(false);

  //const [volume, setVolume] = useState(0.5);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [downloadLoading, setDownloadLoading] = useState(false);
  //const isMobile = useMediaQuery('(max-width: 600px)');
  //const isSmallScreen = useMediaQuery('(max-width: 1000px)');

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.playbackRate = 1;
    }
    setPlaybackSpeed(1);

    const handleWaiting = () => setLoading(true);
    const handleCanPlay = () => setLoading(false);
    const handleLoadedMetadata = () => {
      try {
        if (video) {
          setDuration(video.duration);
        }
      } catch (error) {
        console.error('Error setting duration:', error);
      }
    };

    const handleTimeUpdate = () => {
      try {
        if (video) {
          setCurrentTime(video.currentTime);
        }
      } catch (error) {
        console.error('Error updating time:', error);
      }
    };

    try {
      video?.addEventListener('waiting', handleWaiting);
      video?.addEventListener('canplay', handleCanPlay);
      video?.addEventListener('loadedmetadata', handleLoadedMetadata);
      video?.addEventListener('timeupdate', handleTimeUpdate);
    } catch (error) {
      console.error('Error adding event listeners:', error);
    }

    return () => {
      try {
        video?.removeEventListener('waiting', handleWaiting);
        video?.removeEventListener('canplay', handleCanPlay);
        video?.removeEventListener('loadedmetadata', handleLoadedMetadata);
        video?.removeEventListener('timeupdate', handleTimeUpdate);
      } catch (error) {
        console.error('Error removing event listeners:', error);
      }
    };
    //eslint-disable-next-line
  }, []);

  // const handlePlayPause = () => {
  //   const video = videoRef.current;
  //   try {
  //     if (video) {
  //       if (video.paused) {
  //         video.play();
  //         setPaused(false);

  //         // Track play event
  //         window.dataLayer.push({
  //           event: 'video_played',
  //           videoHeader: videoName,
  //         });

  //         // Clear the headers to avoid carryover to other events
  //         window.dataLayer.push({
  //           videoHeader: undefined,
  //           imageHeader: undefined,
  //         });
  //       }
  //       else {
  //         video.pause();
  //         setPaused(true);

  //         // Track pause event
  //         window.dataLayer.push({
  //           event: 'video_paused',
  //           videoHeader: videoName,
  //         });

  //         // Clear the headers to avoid carryover to other events
  //         window.dataLayer.push({
  //           videoHeader: undefined,
  //           imageHeader: undefined,
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     toast.error(error);
  //   }
  // };

  const handlePlayPause = () => {
    const video = videoRef.current;
    try {
      if (video) {
        // Extract storeName from videoHeader
        const storeName = videoName?.split(' -- ')[0].trim() || 'videoName';
        if (!storeName) {
          return;
        }

        window.dataLayer = window.dataLayer || [];

        let storeCodeCounts = window.storeCodeCounts || {};
        storeCodeCounts[storeName] = (storeCodeCounts[storeName] || 0) + 1;
        window.storeCodeCounts = storeCodeCounts;

        if (video.paused) {
          video.play();
          setPaused(false);

          window.dataLayer.push({
            event: 'video_played',
            videoHeader: storeName,
            storeCodeCount: storeCodeCounts[storeName], // Send the updated visit count
          });

          window.dataLayer.push({
            videoHeader: undefined,
            imageHeader: undefined,
            storeCodeCount: undefined,
          });
        } else {
          video.pause();
          setPaused(true);

          window.dataLayer.push({
            event: 'video_paused',
            videoHeader: storeName,
            storeCodeCount: storeCodeCounts[storeName], // Send the updated visit count
          });

          // Clear the headers to avoid carryover to other events
          window.dataLayer.push({
            videoHeader: undefined,
            imageHeader: undefined,
            storeCodeCount: undefined,
          });
        }
      }
    } catch (error) {
      toast.error(error);
      console.error('Error handling play/pause:', error);
    }
  };

  const handleMuteUnmute = () => {
    const video = videoRef.current;
    try {
      if (video) {
        video.muted = !muted;
        setMuted(!muted);
      }
    } catch (error) {
      toast.error(`Error toggling mute: ${error.message}`);
    }
  };

  // const handleShareClick = () => {
  //   if (navigator.share) {
  //     navigator.share({
  //       title: "Share Media",
  //       text: "Check out this video!",
  //       url: src,
  //     }).catch((error) => console.error("Error sharing:", error));
  //   } else {
  //     navigator.clipboard.writeText(src).then(() => {
  //       toast.success("Link copied to clipboard!");
  //     }).catch((error) => {
  //       toast.error("Failed to copy the link.");
  //     });
  //   }
  // };

  // const handleVolumeChange = (e) => {
  //   const video = videoRef.current;
  //   try {
  //     if (video) {
  //       const newVolume = parseFloat(e.target.value);
  //       video.volume = newVolume;
  //       setVolume(newVolume);
  //     }
  //   } catch (error) {
  //     toast.error(`Error changing volume: ${error.message}`);
  //   }
  // };

  const handleFullscreen = () => {
    const video = videoRef.current;
    try {
      if (isIOS && video) {
        video.webkitEnterFullscreen();
      } else {
        const videoContainer = document.getElementById('zoom-video-container');
        if (videoContainer) {
          const isCurrentlyFullscreen = document.fullscreenElement || document.webkitFullscreenElement;
          if (isCurrentlyFullscreen) {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            }
          } else {
            if (videoContainer.requestFullscreen) {
              videoContainer.requestFullscreen();
            } else if (videoContainer.webkitRequestFullscreen) {
              videoContainer.webkitRequestFullscreen();
            }
          }
        }
      }
    } catch (error) {
      toast.error(`Error toggling fullscreen: ${error.message}`);
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      try {
        const isCurrentlyFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
        setIsFullscreen(!!isCurrentlyFullscreen);
        const video = videoRef.current;
        if (video) {
          if (isCurrentlyFullscreen) {
            video.style.width = '100%';
            video.style.height = '100vh';
          } else {
            video.style.width = '100%';
            video.style.height = '94vh';
          }
        }
      } catch (error) {
        console.error('Error handling fullscreen change:', error);
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      try {
        document.removeEventListener('fullscreenchange', handleFullscreenChange);
        document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
        document.removeEventListener('msfullscreenchange', handleFullscreenChange);
      } catch (error) {
        console.error('Error removing fullscreen change event listeners:', error);
      }
    };
    //eslint-disable-next-line
  }, []);

  // const handleProgressChange = (e) => {
  //   const video = videoRef.current;
  //   try {
  //     if (video) {
  //       const newTime = parseFloat(e.target.value);
  //       video.currentTime = newTime;
  //       setCurrentTime(newTime);
  //     }
  //   } catch (error) {
  //     toast.error(`Error changing progress: ${error.message}`);
  //   }
  // };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };  

  const handleDownload = async () => {
    const video = videoRef.current;
    if (video) {
      const filename = `${videoName}.mp4`; // Adjust the file extension as per your video format
      setDownloadLoading(true);
      toast.success('Downloading is in Progress....');
      try {
        const response = await fetch(video.src);
        if (!response.ok) {
          throw new Error(`Failed to download video: ${response.statusText}`);
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        setDownloadLoading(false);
        toast.success('Video downloaded successfully.');
      } catch (error) {
        toast.error(`Error downloading video: ${error.message}`);
        setDownloadLoading(false);
      }
    } else {
      toast.error('Video element not found.');
      setDownloadLoading(false);
    }
  };

  const handlePlaybackSpeedChange = (e) => {
    const video = videoRef.current;
    try {
      if (video) {
        const newSpeed = parseFloat(e.target.value);
        video.playbackRate = newSpeed;
        setPlaybackSpeed(newSpeed);
      }
    } catch (error) {
      toast.error(`Error changing playback speed: ${error.message}`);
    }
  };

  const handleProgressClick = (e) => {
    try {
      // Prevent default touch behavior
      e.preventDefault();

      const progressBar = e.currentTarget;

      // Determine if it's a touch or mouse event
      const isTouchEvent = e.type === 'touchstart';

      // Use clientX for mouse events and the first touch's clientX for touch events
      const clientX = isTouchEvent ? e.touches[0].clientX : e.clientX;

      // Calculate click position relative to the progress bar
      const clickPosition = clientX - progressBar.getBoundingClientRect().left;

      // Calculate the ratio of the click position
      const clickRatio = clickPosition / progressBar.offsetWidth;

      // Calculate the new time in the video
      const newTime = duration * clickRatio;

      if (videoRef.current) {
        videoRef.current.currentTime = newTime;
        setCurrentTime(newTime);
      }
    } catch (error) {
      toast.error(`Error seeking video: ${error.message}`);
    }
  };

  return (
    <div id="zoom-video-container">
      <TransformWrapper>
        <TransformComponent>
          <video ref={videoRef} src={src} download={true} className="livePageIcons" />
        </TransformComponent>
      </TransformWrapper>

      <div className="controls-div" style={{ paddingBottom: isFullscreen ? "24px" : "4px" }}>
        <div className='controls-top-container'>
          {/* <input
            type="range"
            className="progress-range"
            onChange={handleProgressChange}
            value={currentTime}
            step="0.1"
            min="0"
            max={duration}
            style={{ width: "100%" }}
          /> */}
          <div
            className="progress-bar-container"
            onClick={handleProgressClick}
            onTouchStart={handleProgressClick}
          >
            <div className="progress-bar-background">
              <div
                className="progress-bar"
                style={{ width: `${(currentTime / duration) * 100}%` }}
              >
                <div className="progress-dot"></div> {/* Dot at the end of the played line */}
              </div>
            </div>
          </div>

        </div>
        <div className='controls-bottom-container'
        >
          <div className="controls-left-container">
            <button onClick={handlePlayPause}>
              {paused ? <PlayArrowIcon id="MaximizedVideoPageIcons" /> : <PauseIcon id="MaximizedVideoPageIcons" />}
            </button>
            <div className="time-display" style={{ color: "white", fontSize: "14px" }}>
              {formatTime(currentTime)}  / {formatTime(duration)}
            </div>
            {/* <div style={{ display: isFullscreen ? "block" : "none" }}>
              <select value={playbackSpeed} onChange={handlePlaybackSpeedChange} className="playback-speed-select">
                <option value="0.25">0.25x</option>
                <option value="0.5">0.5x</option>
                <option value="1">1x</option>
                <option value="1.5">1.5x</option>
                <option value="2">2x</option>
                <option value="3">3x</option>
              </select>
            </div> */}
            <div>
              <PlaybackSpeedDropDown playbackSpeed={playbackSpeed} handlePlaybackSpeedChange={handlePlaybackSpeedChange} />
            </div>
          </div>
          <div className="controls-right-container">
            <button onClick={handleDownload}  >
              {downloadLoading ? (
                <ProgressSpinner
                  style={{
                    width: '25px',
                    height: '25px',
                    marginLeft: '10px',
                  }}
                  strokeWidth="8"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                />
              ) : (
                <GetAppIcon id="MaximizedVideoPageIcons" />
              )}
            </button>
            {/* <Tooltip title="Share">
              <span
                className="InternalPageShareIcon"
                style={{ cursor: "pointer",color:"white" }}
                onClick={handleShareClick}
              >
                <ShareIcon />
              </span>
            </Tooltip> */}
            <button onClick={handleMuteUnmute}>
              {muted ? <VolumeOffIcon id="MaximizedVideoPageIcons" /> : <VolumeUpIcon id="MaximizedVideoPageIcons" />}
            </button>
            {/* <input
              type="range"
              style={{ display: isFullscreen && !isMobile ? 'block' : 'none' }}
              className="volume-range"
              onChange={handleVolumeChange}
              value={volume}
              step={0.1}
              min={0}
              max={1}
            /> */}
            <button onClick={handleFullscreen}>
              {isFullscreen ? <FullscreenExitIcon id="MaximizedVideoPageIcons" /> : <FullscreenIcon id="MaximizedVideoPageIcons" />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomVideoPlayerSecond;
